import { useContext } from 'react';
import { AuthContext } from '@/app/providers/AuthContext';

/**
 * Hook to access authentication state from AuthProvider context.
 * This is the single source of truth for authentication status in the app.
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
}
